module.exports = __webpack_public_path__ + "img/file-earmark-ppt.a85c2534.svg";